import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { ButtonModule } from '@teamfoster/sdk/button';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaV3Module } from 'ng-recaptcha-2';
import { NewsletterFormComponent } from 'src/app/standalone/components/newsletter-form/newsletter-form.component';

@Component({
    selector: 'app-content-block-newsletter',
    imports: [ButtonModule, DictionaryNgrxModule, ReactiveFormsModule, RecaptchaV3Module, NewsletterFormComponent],
    templateUrl: './content-block-newsletter.component.html',
    styleUrl: './content-block-newsletter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockNewsletterComponent extends ContentBlockBaseComponent {}
